import React, { Component } from 'react';
import { Message } from 'semantic-ui-react';

export default class Announcements extends Component {
  render() {
    return (
      <Message warning>
        <Message.Header>
          The open-book take-home final exam will be released, on Canvas, at 11:55pm on December 4th and due, also on Canvas, at 11:55pm on Decemeber 5th. Good luck!
        </Message.Header>
      </Message>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/announcements.js